import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Link } from "gatsby"

class ServicesTwo extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #111;
            padding: 20px 0 30px 0;
            .heading {
                width: 100%;
            }                    
        `

        const ServiceRow = styled(Row)`
            margin-top: 150px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;
            
            &:hover {
                color: #0174c3 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `
        const ServiceHeading3 = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;            
            &:hover {
                color: #e44100 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #fff;
            margin-bottom: 5px;
        `

        const ServiceSeparatorw = styled.div`
            height: 2px;
            width: 50px;
            background-color: #0174c3;
            margin-bottom: 5px;
        `

        const ServiceSeparatorp = styled.div`
            height: 2px;
            width: 50px;
            background-color: #e44100;
            margin-bottom: 5px;
        `

        const ServiceNumber = styled.p`
            position: absolute;
            font-size: 60px;
            color: #fff;
            font-weight: 900;
            top: -80px;
            opacity: .2;
            margin-bottom: 20px;
            transition: .2s;
        `

        const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .4 !important;
                color: #fff;
            }
        `

        const ServiceText = styled.p`
            font-size: 17px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;
        `

        const ServiceTextv = styled.p`
            font-size: 17px;
            font-weight: 300;
            color: #7dfa06;
            padding-right: 25px;
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #fff;            
        `

        const Color = styled.span`            
            color: #0174c3;            
        `

        const Color1 = styled.span`            
            color: #e44100;            
        `

        const Colorv = styled.span`
            font-weight: bold;            
            color: #7dfa06;            
        `

        const Colorb = styled.span`
            font-weight: bold;            
            color: #fff;            
        `

        const AboutContainer = styled(Container)`
            padding: 250px 0;
            @media (max-width: 500px) {
                padding: 50px 20px;
            }
            @media (max-width:767px) {
                padding: 100px 0;
            }
        `

        const Heading2 = styled.h2`
            font-size: 50px;
            font-family: Poppins;
            color: #7dfa06;
            line-height: 60px;
            text-align: center;
            padding-bottom: 80px;        
        `

        const Heading3 = styled.h3`
        font-size: 30px;
        line-height: 60px;
        font-family: "Montserrat", sans-serif;        
        font-weight: bold;        
        @media (min-width:768px) and (max-width:1500px) {
          font-size: 30px;
          line-height: 50px;
        }
        @media (max-width:767px) {
          font-size: 30px;
          line-height: 30px;
          text-align: left;
        }
        @media (min-width:15001px) and (max-width:1600px) {
          font-size: 30px;
          line-height: 50px;
          margin-top: 50px;
        }
        `

        const Headinga = styled(Link)`        
        color: #c1eb18;
        transition: .5s;
          &:hover {
          color: #ffffff;
          text-decoration: none;
        }
        `
        const Heading2b = styled.h2`
            transform: translate(0px, -100px);
            transition: 1s;
            margin-top: 150px;
            font-size: 70px;
            line-height: 80px;
            font-family: Teko;
            font-weight: 500;
            color: rgb(255, 255, 255);
            text-align: center;
            text-transform: uppercase;          
        `
        const ColorV = styled.span`            
            color: #c1eb18;
            font-family: Teko;                        
        `

        return (
            <Section>
                <Container>
                    <Heading2b>Certificados SSL Flex y SAN: <ColorV>Flexibilidad Total</ColorV></Heading2b>
                    <Text>
                        DigiCert ofrece certificados que admiten cualquier tipo de configuración de dominio y se pueden solicitar como certificados de
                        dominio único o multidominio con cualquier combinación de nombre de dominio completo (FQDN), SAN o Wildcard.
                    </Text>
                    <ServiceRow>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    <Color>Flex</Color>
                                </ServiceNumber>
                                <ServiceHeading>
                                    <Link to="/ssl-geotrust#SAN">Tecnología SSL Flex </Link>
                                </ServiceHeading>
                                <ServiceSeparatorw />
                                <ServiceText>
                                    Históricamente, habían certificados <Colorb>Comodín (Wildcard)</Colorb> y <Colorb>multidominio (SAN)</Colorb> separados
                                    que no permitían tener diferentes tipos de SAN. Ahora puedes combinar Wildcard,
                                    direcciones IP y dominios estándar. <Colorv>FLEX SSL</Colorv> permite proteger dominios individuales estándar,
                                    subdominios, direcciones IP públicas e incluso dominios Wildcard a la vez.
                                </ServiceText>
                                <ServiceText>
                                    Combina dominios (dominio.com), subdominios (*.dominio.co), y direcciones IP en un solo certificado. Ideal para empresas
                                    o entidades estatales en Colombia.
                                </ServiceText>
                                <ServiceTextv>
                                    dominio.tld (dominio.com, dominio.net)
                                </ServiceTextv>
                                <ServiceTextv>
                                    *.dominio.tld (sub.dominio.com, tienda.dominio.net, otro.dominio.co)
                                </ServiceTextv>
                                <ServiceTextv>
                                    Dirección IP (1.13.80.23)
                                </ServiceTextv>
                                <Heading3>
                                    <Headinga to="/ssl-geotrust#SAN">
                                        SSL FLEX
                                    </Headinga>
                                </Heading3>
                            </ServiceElement>

                        </Col>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    <Color>www</Color>
                                </ServiceNumber>
                                <ServiceHeading>
                                    Con o sin www
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    En el mundo digital actual, la seguridad es esencial, y los certificados SSL son la clave
                                    para proteger la información en línea. La versatilidad de SSL que asegura tanto <Colorv>con, como
                                        sin www</Colorv> garantiza una protección completa, sin importar cómo los usuarios accedan a tu
                                    sitio web. Descubre cómo esta solución simple pero efectiva puede fortalecer la confianza
                                    en línea y proteger la integridad de tu presencia digital.
                                </ServiceText>
                            </ServiceElement>

                        </Col>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    SSL <Color1>SAN</Color1>
                                </ServiceNumber>
                                <ServiceHeading3>
                                    <Link to="/certificados-digitales-ssl-san-ucc">Certificados SSL SAN</Link>
                                </ServiceHeading3>
                                <ServiceSeparatorp />
                                <ServiceText>
                                    En el constante flujo del universo digital actual, donde la expansión de proyectos abarca un espectro
                                    diverso de dominios y subdominios, la seguridad emerge como el cimiento inquebrantable. En este escenario,
                                    los <Colorv>Certificados SSL SAN (Subject Alternative Name)</Colorv> irrumpen como guardianes de confianza,
                                    otorgando una protección integral que trasciende las fronteras digitales. Conocidos también
                                    como <Colorv>Certificados multi-dominio o SAN/UCC</Colorv>, son la piedra angular que asegura la integridad
                                    y confidencialidad en la interacción en línea.
                                </ServiceText>
                                <ServiceText>
                                    Protege múltiples dominios y subdominios en Barranquilla o Bucaramanga con un solo certificado SAN. Perfecto para empresas.
                                </ServiceText>
                                <Heading3>
                                    <Headinga to="/certificados-digitales-ssl-san-ucc">
                                        Certificados SSL SAN
                                    </Headinga>
                                </Heading3>
                            </ServiceElement>

                        </Col>
                    </ServiceRow>
                </Container>
                <AboutContainer>
                    <Row>
                        <Col md={12}>
                            <Heading2>Garantía de reembolso por 30 días</Heading2>
                            <Text>
                                Garantizamos tu satisfacción. Si en los primeros 30 días no estás completamente satisfecho,
                                te reembolsamos sin preguntas. Tu confianza es nuestra prioridad.
                            </Text>
                        </Col>
                    </Row>
                </AboutContainer>
            </Section>
        )
    }

}

export default ServicesTwo